import { Component } from 'react';
import ReactModal from '../../../components/Modal';
import { defaultWords } from './config';
import { updateQualifiers } from './query';
import AutocompleteInput from '../CommerceViewDetail/components/ContentGaps/autoCompleteInput';
import { getDomains } from '../CommerceViewDetail/components/ContentGaps/query';
import { withTranslation } from 'react-i18next';

class CommerceSettingsModal extends Component {
    constructor(props) {
        super();

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onChangeOwnDomain = this.onChangeOwnDomain.bind(this);

        this.state = {
            loading: false,
            qualifiers: props.selectedItem?.qualifiers || defaultWords?.join(','),
            own_domain: props.selectedItem?.own_domain ?? '',
        };
    }

    async componentDidMount() {
        try {
            if (!this.props.domains_for_select) {
                this.query = getDomains({ project_id: this.props?.selectedItem?.project_id });
                this.query.bind(this.setState.bind(this));
                this.query.update();
            }
        } catch (err) {
            console.log(err);
        }
    }

    onChange(e, key) {
        const value = e.target.value;

        this.setState({
            [key]: value,
        });
    }

    async onSubmit(e) {
        e.preventDefault();
        try {
            this.setState({
                loading: true,
            });
            const qualifiers = this.state.qualifiers
                ?.split(',')
                ?.map((item) => item.trim())
                ?.join();

            const body = {
                project_id: this.props?.selectedItem?.project_id,
                qualifiers,
            };

            if (this.props.includeDomain) body.own_domain = this.state.own_domain;

            const response = await updateQualifiers(body, this.props.csrf_token);
            const data = await response.json();
            if (this.props.updateItemQuiliers) this.props.updateItemQuiliers(body);
            if (response.status === 200) {
                this.props.onOpenMessage(data?.message, 'success');
                this.props.onClose();
            } else {
                this.props.onOpenMessage(data?.message, 'error');
            }
        } catch (err) {
            console.log(err);
            this.props.onOpenMessage(err?.message, 'error');
        } finally {
            this.setState({
                loading: false,
            });
        }
    }

    onChangeOwnDomain(value) {
        this.setState({
            own_domain: value,
        });
    }

    render() {
        const { t } = this.props;

        const domains = this.state.data;
        return (
            <ReactModal
                modalState={this.props.isOpen}
                className="width-sm"
                onClose={this.props.onClose}
            >
                <form onSubmit={this.onSubmit}>
                    <h2>{t('commerce.report.settings.header')}</h2>
                    {this.props.includeDomain && (
                        <div className="commerce-autocomplete mb-3">
                            <label>{t('commerce.report.settings.ownDomain')}</label>
                            <AutocompleteInput
                                domains={domains}
                                onChange={this.onChangeOwnDomain}
                                showPlus={false}
                                item={this.state.own_domain}
                                dontShowMinus
                                dontShowLabel
                            />
                        </div>
                    )}
                    <div className="pages-modal-container">
                        <div className="text-field mb-3">
                            <label>{t('commerce.report.settings.qualifiers')}</label>
                            <textarea
                                className="form-control qualifieres-input"
                                onChange={(e) => this.onChange(e, 'qualifiers')}
                                value={this.state.qualifiers}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button
                            className="button button-filled button-primary width-sm btn"
                            style={{ lineHeight: 'unset', marginRight: '10px' }}
                            disabled={this.state.loading}
                        >
                            {t('commerce.report.settings.save')}
                        </button>
                        <button
                            type="button"
                            className="button button-outline button-primary width-sm btn"
                            onClick={this.props.onClose}
                            style={{ lineHeight: 'unset' }}
                        >
                            {t('commerce.report.settings.close')}
                        </button>
                    </div>
                </form>
            </ReactModal>
        );
    }
}

export default withTranslation()(CommerceSettingsModal);
